import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http'

import { Observable } from 'rxjs/Observable';

import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { IVendedor } from '../../interface/iConcorrencia'
import { iDetalhesVendas } from '../../interface/iDetalhesVendas';


@Injectable()
export class ConcorrenciaProvider {

     apiRoot: string = 'http://192.99.185.73:8070';
  apiRootSDP: string = 'http://66.70.157.102:8071';

  public status: any;

  constructor(private _http: HttpClient){

    console.log('Hello ConcorrenciaProvider Provider');

  }

  getConnect(): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
               .get<IVendedor[]>(this.apiRoot + '/Vendedor/Buscar?parametros.codigo=90723667', { headers: header })
               .do(data => JSON.stringify(data))
               .catch(this.handleError);
  }

  getVendedor(Codigo: string): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Vendedor/Buscar?parametros.codigo=' + Codigo,  { headers: header })
      .do(data => {JSON.stringify(data); console.log(data)})
      .catch(this.handleError);
  }

  getRelatorioAnunciosVinculadosPerdendo(codigosVendedor: string,
                                         categoriaMLB: string,
                                         limit: number,
                                         agrupar: boolean,
                                         ativos: boolean): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Vendedor/RelatorioAnunciosVinculadosPerdendo'
                                     + '?parametros.codigosVendedor=' + codigosVendedor
                                     + '&categoriaMLB=' + categoriaMLB
                                     + '&limit=' + limit
                                     + '&agrupar=' + agrupar
                                     + '&somenteAtivos=' + limit,  { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  getBuscarDetalhesVenda(CodigoVendedor: string,
                         DataInicial: string,
                         DataFinal: string,
                         CategoriaMLB: string,
                         limite: number,
                         start: number): Observable<iDetalhesVendas[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

    return this._http
      .get<iDetalhesVendas[]>(this.apiRoot +'/Vendedor/BuscarDetalhesVenda?codigoVendedor=' + CodigoVendedor + '&dataInicial=' + DataInicial + '&dataFinal=' + DataFinal + '&categoriaMLB=' + CategoriaMLB + '&limit=' + limite + '&skip=' + start, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  postAtualizarVendedor(CodigoVendedor: string)
  {
  const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

  return this._http
  .get(this.apiRoot +'/Anuncios/AtualizarAnunciosVendedor?vendedor=' + CodigoVendedor, { headers: header })
  .catch(this.handleError);
  }

  getBuscarTotalVenda(Codigo: string, DataVenda: string): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Vendedor/BuscarTotalVenda?codigoVendedor=' + Codigo + '&data=' + DataVenda, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  getAtividades(codigo: string): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
               .get<IVendedor[]>(this.apiRoot +'/Atividades/Listar?parametros.visualizado=false&parametros.codigoVendedor=' + codigo + '&parametros.limite=30', { headers: header })
               .do(data => JSON.stringify(data))
               .catch(this.handleError);
  }

  getAtividadesFiltro(codigo: string, event: number): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Atividades/Listar?parametros.visualizado=false&parametros.codigoVendedor=' + codigo + '&parametros.tipoAtividade=' + event + '&parametros.limite=30', { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  buscaVendedor(vendedor: string): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Vendedor/BuscarVendedor?apelido=' + vendedor, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  getVendedorAcompanhado(): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Vendedor/Listar', { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  inserirNovosNegocios(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this._http
      .post(this.apiRoot + '/Anuncios/InserirNovosNegocios?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  inserirNovosKits(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this._http
      .post(this.apiRoot + '/Anuncios/InserirKit?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  inserirShopingPreco(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this._http
      .post(this.apiRoot + '/Anuncios/InserirShoppingPrecos?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  vincularShopingPreco(CodigoMLB: string, CodigoSKU){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let username = localStorage.getItem('userLogin');

    return this._http

      // .post(this.apiRoot + '/Anuncios/VincularShoppingPrecos?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })

      .post(this.apiRootSDP + '/Concorrente/CriarRelacionamento' , {
        "Mlb": CodigoMLB,
        "CodigoExternoPai": CodigoSKU,
        "Usuario": JSON.parse(username).user_id
      }, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  revisarVinculoShoppingPrecos(CodigoMLB: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let userEmail = localStorage.getItem('userLogin');

    return this._http

      // .post(this.apiRoot + '/Anuncios/VincularShoppingPrecos?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })

      .post(this.apiRootSDP + '/Anuncios/RevisarVinculoShoppingPrecos?'
                            + 'Mlb=' + CodigoMLB
                            + 'email=' + JSON.parse(userEmail).user_mail, { }, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  ExportarDetalhesVenda(CategoriaMLB: string, DataInicial, DataFinal, CodigoVendedor:string){

    const header = new HttpHeaders({'Content-Type':  'application/octet-stream', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

    return this._http

      .get(this.apiRoot + '/Vendedor/ExportarDetalhesVenda?'
                        + 'codigoVendedor=' + CodigoVendedor
                        + '&dataInicial=' + DataInicial
                        + '&dataFinal=' + DataFinal
                        + '&categoriaMLB=' + CategoriaMLB, { headers: header, responseType: 'blob' })
      .do(blob => blob)
      .catch(this.handleError);

  }

  saveVendedorAcompanhado(codigo: string): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
      .get<IVendedor[]>(this.apiRoot +'/Vendedor/SalvarVendedorConnect?codigoVendedor=' + codigo, { headers: header })
      .do(data => {
          JSON.stringify(data)
        })
      .catch(this.handleError);
  }

  removeVendedorAcompanhado(codigo: string): Observable<IVendedor[]>{

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this._http
      .delete<IVendedor[]>(this.apiRoot +'/Vendedor/Remover/' + codigo, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};
    if (error.error instanceof Error) {

        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;

        console.log(error.error);

    } else {

        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = { status: error.status, message: error.error.Message };

        console.log(error.error);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/concorrencia/concorrencia.ts